import { render, staticRenderFns } from "./BasePopup.vue?vue&type=template&id=b0b8ebaa&scoped=true&"
import script from "./BasePopup.vue?vue&type=script&lang=js&"
export * from "./BasePopup.vue?vue&type=script&lang=js&"
import style0 from "./BasePopup.vue?vue&type=style&index=0&id=b0b8ebaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b8ebaa",
  null
  
)

export default component.exports